
import { MultiMediaBasicInfo } from './MultiMediaBasicInfo';
import { ImageCarouselActionsTypes } from '../enums/enums';

export class ImageCarouselActions{
    type : ImageCarouselActionsTypes;
    selectedMediaInfo : MultiMediaBasicInfo;    
}